export class ContactSupportAITrackers {
  static readonly CONTACT_SUPPORT_AI_OPEN = '[Contact Support AI] open';
  static readonly CONTACT_SUPPORT_AI_CLOSE = '[Contact Support AI] close';
  static readonly CONTACT_SUPPORT_AI_QUERY_TYPE_CHANGE = '[Contact Support AI] query type change';
  static readonly CONTACT_SUPPORT_AI_QUERY_SUBMIT = '[Contact Support AI] query submit';
  static readonly CONTACT_SUPPORT_AI_QUERY_SUCCESS = '[Contact Support AI] query success';
  static readonly CONTACT_SUPPORT_AI_QUERY_ERROR = '[Contact Support AI] query error';
  static readonly CONTACT_SUPPORT_AI_MAXIMIZE_SCREEN = '[Contact Support AI] maximize screen';
  static readonly CONTACT_SUPPORT_AI_MINIMIZE_SCREEN = '[Contact Support AI] minimize screen';
  static readonly CONTACT_SUPPORT_AI_BACK = '[Contact Support AI] back';
  static readonly CONTACT_SUPPORT_AI_TALK_TO_SUPPORT = '[Contact Support AI] Talk to Support';
  static readonly CONTACT_SUPPORT_AI_OPEN_SUPPORT_CHAT = '[Contact Support AI] open support chat';
  static readonly CONTACT_SUPPORT_AI_RESOLVE_ISSUE_SUCCESS = '[Contact Support AI] resolve issue success';
  static readonly CONTACT_SUPPORT_AI_TICKET_ERROR = '[Contact Support AI] ticket error';
  static readonly CONTACT_SUPPORT_AI_TICKET_SUCCESS = '[Contact Support AI] ticket success';
}